<section class="page-with-tabs">
  <!-- Page Header -->
  <div class="page-title">
    <ng-container>
      <div style="height: 23px; overflow: visible">
        <a mat-icon-button (click)="back()">
          <mat-icon>arrow_back</mat-icon>
        </a>
        <h2 class="d-inline-block">
          {{ 'NotificationLogs.NotificationsHistoryTitle' | translate }}
        </h2>
      </div>
    </ng-container>
  </div>

  <!-- Page Body -->
  <div class="container m-4">
    <div class="row">
      <div class="col">
        <mat-card>
          <mat-card-content>
            <mat-progress-bar
              mode="query"
              color="primary"
              *ngIf="isLoading; else loaded"
            >
            </mat-progress-bar>
            <ng-template #loaded>
              <div *ngIf="NotificationLogs.length; else noData">
                <!-- Headers -->
                <div class="notification-list headers">
                  <div>{{ 'NotificationLogs.Subject' | translate }}</div>
                  <!-- <div>{{ 'NotificationLogs.Body' | translate }}</div> -->
                  <div>{{ 'NotificationLogs.DateSent' | translate }}</div>
                  <div>{{ 'NotificationLogs.DateRead' | translate }}</div>
                </div>

                <!-- List Notifications -->
                <div
                  class="notification-list"
                  *ngFor="let nl of NotificationLogs"
                  (click)="selectNotificationLog(nl)"
                >
                  <div [class]="nl.dateRead.getTime() < 0 ? 'allbold' : ''">
                    <a [title]="nl.englishSubject" class="text-primary">
                      <mat-icon
                        *ngIf="nl.dateRead.getTime() < 0"
                        class="align-middle"
                        >email</mat-icon
                      >
                      <mat-icon
                        *ngIf="nl.dateRead.getTime() > 0"
                        class="align-middle"
                        >drafts</mat-icon
                      >&nbsp;&nbsp;
                      <span *ngIf="localeService.getLocale() == 'en-CA'">{{
                        nl.englishSubject
                      }}</span>
                      <span *ngIf="localeService.getLocale() == 'fr-CA'">{{
                        nl.frenchSubject
                      }}</span>
                    </a>
                  </div>
                  <!-- TODO maybe body preview... needs to render html tags
                  <div
                    [class]="
                      nl.dateRead.getTime() < 0 ? 'allbold body' : 'body'
                    "
                  >
                    <span *ngIf="localeService.getLocale() == 'en-CA'">{{
                      nl.englishBody
                    }}</span>
                    <span *ngIf="localeService.getLocale() == 'fr-CA'">{{
                      nl.frenchBody
                    }}</span>
                  </div>-->
                  <div [class]="nl.dateRead.getTime() < 0 ? 'allbold' : ''">
                    {{ nl.createdDate | kortoDate }}
                  </div>
                  <div [class]="nl.dateRead.getTime() < 0 ? 'allbold' : ''">
                    {{
                      nl.dateRead.getTime() < 0 ? '' : (nl.dateRead | kortoDate)
                    }}
                  </div>
                </div>
              </div>

              <!-- No Data Message -->
              <ng-template #noData>{{
                'NotificationLogs.NoNotifications' | translate
              }}</ng-template>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</section>
